<div class="privacy-content">
    <!--section -->
    <section class="parallax-section" data-scrollax-parent="true">
        <div class="bg1 par-elem " data-scrollax="properties: { translateY: '30%' }"
            style="background-color: gray; transform: translateZ(0px) translateY(-4.22535%);">
        </div>
        <!-- <img class="bg1 par-elem " src="assets/images/Contact.jpg" alt=""
      style="transform: translateZ(0px) translateY(-4.22535%);"> -->
        <div class="privacy-container">
            <div class="col-md-8 offset-md-2 text-center">
                <h2 class="section-title v1" style="color: white;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 0px;
        padding-bottom: 0px;">USER TERMS AND CONDITIONS – FLEXO PROPTECH PVT. LTD.</h2>
            </div>
        </div>
    </section>
    <section class="gray-section" id="sec1">
        <div class="privacy-container">
            <div class="row">
                <div class="col-md-12">
                    <div class="list-single-main-wrapper fl-wrap" id="sec2">
                        <!-- article> -->
                        <article>
                            <div style="text-align: left;">
                                <p>
                                    Welcome to www.flexospaces.com. These Terms & Conditions govern your use of the
                                    platform owned and operated by Flexo Proptech Pvt. Ltd., a company incorporated
                                    under the laws of India, (herewith referred to as “Flexo”, “we”, “us”, or “our”),
                                    including the website www.flexospaces.com and its related mobile applications,
                                    tools, and services collectively referred to as the "Platform". By visiting and
                                    using the Platform, you agree to comply with these Terms and Conditions and our
                                    Privacy Policy.

                                    We reserve the right to change these Terms from time to time with or without notice.
                                    It is your responsibility to review them periodically. Continued use of the Platform
                                    constitutes your acceptance of changes.

                                    PLEASE READ THIS TERMS OF SERVICE AGREEMENT CAREFULLY. BY USING THIS WEBSITE OR
                                    ORDERING PRODUCTS OR BOOKING SPACES FROM THIS WEBSITE YOU AGREE TO BE BOUND BY ALL
                                    OF THE TERMS AND CONDITIONS OF THIS AGREEMENT.
                                </p>
                                <p>
                                    This Privacy Policy applies to current and former visitors to our Flexo
                                    Spaces Platform and to our
                                    online customers. By visiting and/or using our website, you agree to this Privacy
                                    Policy. Flexo
                                    Spaces may change this policy from time to time by updating this page. You should
                                    check this page from
                                    time to time to ensure that you are happy with any changes.
                                </p>
                                <p>
                                    www.flexospaces.com is a property of Flexo Spaces established under laws of India,
                                    having its
                                    registered office at L3A/102 Oakland Park, Yamuna Nagar, Andheri West, Mumbai,
                                    Maharashtra - 400053.
                                </p>
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Scope of Agreement:
                                    </h3>
                                </div>
                                <p>
                                    These Terms govern your relationship with Flexo when listing spaces for short-term
                                    or long-term use via the Platform.
                                </p>
                                <p class="pt-2">
                                     Flexo reserves the right to modify these Terms at any time. Continued use of the
                                    Platform after such modifications constitutes your acceptance of the modified Terms.
                                </p>
                                   
                              
                                
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Responsible Use and Conduct
                                    </h3>
                                </div>
                          
                                    <ul class="ul-1 pl-5">
                                        <li class="">You must ensure all information provided during registration and listing is accurate, complete, and kept up-to-date.</li>
                                        <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>
                                        <li>You agree not to:
                                            <ul class="ul-2 pl-5">
                                                <li>Access or attempt to access the Platform using unauthorized or unethical means.</li>
                                                <li>Engage in activity that disrupts or interferes with the Platform or connected networks.</li>
                                                <li>Copy, duplicate, reproduce, sell, trade, or resell any aspect of the Platform without express authorization.</li>
                                                <li>Submit false, misleading, unlawful, or offensive content.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                

                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Host Eligibility and Obligations
                                    </h3>
                                </div>
                                <ul class="ul-1 pl-5">
                                    <li>You must ensure that your listed spaces comply with all applicable laws, are safe, properly maintained, and suitable for their intended purpose.</li>
                                    <li>Listings must accurately reflect the condition, features, amenities, pricing, availability, operating hours, holidays, and other material aspects.</li>
                                    <li> You agree to keep listings continuously updated and promptly reflect any changes in availability, hours, holidays, etc.</li>
                                    <li>Hosts must honor all confirmed bookings and maintain standards promised to Users.</li>
                                </ul>
                                    

                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                       Subscriptions and Lead Purchases
                                    </h3>
                                </div>
                                <ul class="ul-1 pl-5">
                                    <li>Flexo may offer subscription plans or credit-based packages allowing Hosts to promote listings, gain visibility, or purchase access to qualified leads.</li>
                                    <li>Subscription fees, terms, and conditions will be communicated at purchase and are non-refundable unless otherwise stated.</li>
                                </ul>
                                    
                                    
                                   <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Fees and Payments
                                    </h3>
                                </div>
                                <ul class="ul-1 pl-5">
                                  <li>For short-term bookings (including hourly, daily, weekly, monthly, day passes, virtual offices), Flexo shall charge a Platform Fee as agreed separately or as per Flexo's prevailing standard terms at 20%.</li> 
                                  <li>
                                    Flexo shall charge a Success Fee (also referred to as commission or brokerage fee) for coworking, office leasing, managed offices, or similar transactions, as agreed separately or as per Flexo's prevailing standard terms.
                                  </li>
                                  <li>
                                    Flexo shall deduct applicable fees before remitting payouts to Hosts.
                                  </li>
                                </ul>
                                    
                                    
                              
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Modifications to Listings and Content
                                    </h3>
                                </div>
                                <p>
                                    Flexo may edit, format, crop, resize, optimize, or modify listing content, images, descriptions, and metadata to align with technical requirements, UI/UX, search functionality, or presentation standards, ensuring consistency across the Platform.
                                </p>
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Platform as Intermediary
                                    </h3>
                                </div>
                                <p>
                                  Flexo solely facilitates transactions between Hosts and Users and does not operate or manage listed spaces.
                                </p>
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Intellectual Property and Proprietary Rights
                                    </h3>
                                </div>
                                <ul class="ul-1 pl-5">
                                    <li>All content and intellectual property on the Platform is owned by Flexo.</li>
                                    <li>Hosts grant Flexo a perpetual, royalty-free, worldwide, non-exclusive license to use, reproduce, display, distribute, modify, or adapt any listing content provided by the Host.</li>
                                    <li>Hosts may not use Flexo’s name, logo, trademarks, or proprietary material without express written consent</li>
                                </ul>
                                    
                            
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Content, Third-Party Links
                                    </h3>
                                </div>
                                <ul class="ul-1 pl-5">
                                    <li>
                                        The Platform may contain links to third-party websites for convenience. Flexo is not responsible for third-party content and disclaims all liability for interactions with external websites.
                                    </li>
                                </ul>
                                    
                            
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                         Disclaimer of Warranties
                                    </h3>
                                </div>
                                <p>
                                    The Platform is provided “as is” and “as available”. Flexo disclaims all warranties, express or implied, including but not limited to merchantability, fitness for a particular purpose, and non-infringement.
                                </p>
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Limitation of Liability
                                    </h3>
                                </div>
                                <ul class="ul-1 pl-5">
                                    <li>Flexo’s liability is limited to the amount of fees received by Flexo for the transaction giving rise to a claim.</li>
                                    <li>
                                        Flexo shall not be liable for indirect, incidental, special, or consequential damages (including loss of profits, loss of data, business interruption) arising from your use of the Platform or listings.
                                    </li>
                                </ul>
                                    
                                    
                             
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                         Indemnity
                                    </h3>
                                </div>
                                <p>
                                    Hosts shall indemnify, defend, and hold harmless Flexo, its affiliates, directors, officers, employees, agents, and assigns from all claims, damages, costs, liabilities, and expenses (including reasonable legal fees) arising from:
                                </p>
                                <ul class="ul-1 pl-5 pt-2">
                                    <li> The listing, condition, or operation of spaces.</li>
                                    <li> Inaccuracies in listings.</li>
                                    <li>Breach of these Terms.</li>
                                    <li>Violation of applicable laws.</li>
                                </ul>
                                  
                             
                               
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Termination
                                    </h3>
                                </div>
                                <p>
                                    Flexo may suspend or terminate any Host account or remove listings at its sole discretion for violations of these Terms or behavior that could harm the Platform’s reputation or operations.
                                </p>
                                
                               
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                         Force Majeure
                                    </h3>
                                </div>
                                <p>
                                    Flexo shall not be liable for delays or failures in performance due to events beyond reasonable control, including natural disasters, war, labor disputes, government actions, pandemics, or technical failures.
                                </p>
                                
                                
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Assignment
                                    </h3>
                                </div>
                                <p>
                                    Hosts may not assign their rights or obligations without prior written consent. Flexo may assign its rights and obligations freely.
                                </p>
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Domestic Use
                                    </h3>
                                </div>
                                <p>
                                    The Platform is operated from India. Hosts outside India access the Platform at their own risk and must comply with local laws.
                                </p>
                               
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                        Governing Law and Jurisdiction
                                    </h3>
                                </div>
                                <p>
                                    These Terms are governed by the laws of India, with exclusive jurisdiction in courts of Mumbai, Maharashtra. Hosts waive any objections to venue or jurisdiction.
                                </p>
                               
                                <div class="list-single-main-item-title-1 fl-wrap terms">
                                    <h3>
                                         Entire Agreement
                                    </h3>
                                </div>
                                <p>
                                   These Terms constitute the entire agreement between Hosts and Flexo, superseding prior communications or agreements.
                                </p>
                                
                              
                            </div>
                        </article>
                    </div>
                </div>
                <!--box-widget-wrap -->
            </div>
        </div>
    </section>
</div>